// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MenuTranscibedItem_wrapper__9PXXF","animate":"MenuTranscibedItem_animate__zwmUH","appear":"MenuTranscibedItem_appear__wOPPj"};